@if (widget()) {
  @switch (widget().component.componentType) {
    @case (GuidelineComponentType.Action) {
      <guideline-component-sidebar-action [widget]="widget()" />
    }
    @case (GuidelineComponentType.Criteria) {
      <guideline-component-sidebar-criteria [widget]="widget()" />
    }
    @case (GuidelineComponentType.Condition) {
      <guideline-component-sidebar-condition [widget]="widget()" />
    }
    @case (GuidelineComponentType.Observation) {
      <guideline-component-sidebar-observation [widget]="widget()" />
    }
  }
} @else {
  <shared-sidebar-placeholder />
}
